import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReportService } from '../report.service';
import { NgxExtendedPdfViewerComponent, NgxExtendedPdfViewerService, ProgressBarEvent, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { HttpEventType } from '@angular/common/http';

@Component({
    selector: 'ngx-report-viewer-pdf',
    templateUrl: './report-viewer-pdf.component.html',
})
export class ReportViewerPdfComponent implements OnDestroy {
    loadingMessage: string;
    reportTitle: string;
    reportUrl: string;
    hostUrl: string;
    invokeAction: string;
    showReportPopup: boolean;
    loadingVisible: boolean = false;
    subscription: Subscription;
    fileContent: any;
    fileNameForDownload: string = "document.pdf";
    showError: boolean = false;
    @ViewChild(NgxExtendedPdfViewerComponent, { static: false }) pdfViewer!: NgxExtendedPdfViewerComponent;
    spreadMode: 'off' | 'even' | 'odd' = 'off';
    page: number;
    request: any;
    progresValue: number = 0;
    isCloudDocument: boolean;

    constructor(private reportService: ReportService, private pdfViewerService: NgxExtendedPdfViewerService) {
        pdfDefaultOptions.ignoreDestinationZoom = true;
        this.cancel = this.cancel.bind(this);
        this.subscription = this.reportService.showPdfReport().subscribe(report => {
            this.progresValue = 0;
            this.fileContent = null;
            this.showReportPopup = true;
            this.reportTitle = report.reportTitle;
            this.fileNameForDownload = report.reportTitle + '.pdf';
            if (!!report) {
                this.loadingMessage = report.loadingMessage;
                this.loadingVisible = true;
                if (report.cloudReport) {
                    this.downloadCloudPdf(report.activiteitId);
                } else {
                    this.downloadPdf(report.activiteitId, report.reportName);
                }
            } else {
                this.showError = true;
                this.loadingVisible = false;
            }
        }, (error) => {
            this.showError = true;
            this.loadingVisible = false;
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.fileContent = null;
        this.showError = false;
        this.loadingVisible = false;
        this.progresValue = 0;
    }

    onHidden(event) {
        this.fileContent = null;
        this.showError = false;
        this.loadingVisible = false;
        this.progresValue = 0;
    }


    private downloadPdf(id: number, reportName: string) {
        this.isCloudDocument = false;
        this.request = this.reportService.downloadPdfReport(reportName, id).subscribe(event => {
            switch (event.type) {
                case HttpEventType.DownloadProgress:
                    this.progresValue = (event.loaded / event.total) * 100;
                    break;

                case HttpEventType.Response:
                    this.fileContent = event.body;
                    break;
            }
        }, (error) => {
            this.showError = true;
            this.loadingVisible = false;
        });
    }

    private downloadCloudPdf(id: number) {
        this.isCloudDocument = true;

        this.reportService.downloadCloudPdfReport(id).subscribe({
            next: (fileData) => {
                this.fileContent = fileData.TemporaryAzureUrl;
            }, error: (error) => {
                this.showError = true;
                this.loadingVisible = false;
            }
        });
    }

    cancel() {
        if (!!this.request) {
            this.request.unsubscribe();
        }
        this.showReportPopup = false;
    }

    onPageRendered(): void {
        if (!this.pdfViewerService.isRenderQueueEmpty()) {
            // try again later when the pages requested by the pdf.js core or the user have been rendered
            setTimeout(() => this.onPageRendered(), 100);
        }

        if (this.loadingVisible) this.loadingVisible = false;

        const pagesBefore = this.spreadMode === 'off' ? 2 : 2;
        const pagesAfter = this.spreadMode === 'off' ? 2 : 5;
        let startPage = Math.max(this.page - pagesBefore, 1);
        let endPage = Math.min(this.page + pagesAfter, this.pdfViewerService.numberOfPages());

        const renderedPages = this.pdfViewerService.currentlyRenderedPages();

        for (let page = startPage; page <= endPage; page++) {
            const pageIndex = page - 1;
            if (!this.pdfViewerService.hasPageBeenRendered(pageIndex)) {
                this.pdfViewerService.addPageToRenderQueue(pageIndex);
                break; // break because you can request only one page at a time
            }
        }
    }

    formatStatus(ratio, value) {
        return 'Downloaden: ' + Math.round(ratio * 100) + '%'
    }

    onProgress(event: ProgressBarEvent): void {
        if (this.isCloudDocument) {
            this.progresValue = event.percent;
        }
    }

    pdfLoadingFailed(event) {
        this.showError = true;
        this.loadingVisible = false;
    }

    pdfLoaded(event) {
        // if (this.isCloudDocument) {
        //     this.progresValue = 0;
        //     this.loadingMessage = 'Bezig met openen van het document, bij veel objecten kan dit tot enkele minuten duren....';
        // }
    }
}
